import { render, staticRenderFns } from "./ReportProcessIssue.vue?vue&type=template&id=0d9ebc6d&"
import script from "./ReportProcessIssue.vue?vue&type=script&lang=js&"
export * from "./ReportProcessIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports